<div class="modal-header">
    <div class="d-flex gap-5">
        <span
            header-icon
            class="svg-icon svg-icon-primary svg-icon-2x menu-icon"
        >
            <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.444 5.489c-2.033-.407-2.91-1.387-3.317-3.37a.25.25 0 0 0-.241-.189.25.25 0 0 0-.241.192c-.407 2.033-1.335 2.96-3.317 3.367a.254.254 0 0 0 0 .508c2.033.407 2.906 1.366 3.313 3.349a.25.25 0 0 0 .245.21.25.25 0 0 0 .243-.197c.406-2.034 1.333-2.955 3.315-3.362a.254.254 0 1 0 0-.508Z"
                    fill="#6200b3"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.223 5.24a3.057 3.057 0 0 0-4.323 0L6.87 15.267a5.419 5.419 0 0 0-1.295 2.08l-1.12 3.282a1.087 1.087 0 0 0 1.378 1.38L9.1 20.896a5.42 5.42 0 0 0 2.086-1.299L21.223 9.562a3.057 3.057 0 0 0 0-4.323Zm-2.134 4.334 1.073-1.073A1.557 1.557 0 1 0 17.961 6.3l-1.073 1.073 2.201 2.201Zm-1.06 1.06-2.202-2.2-6.633 6.632a6.214 6.214 0 0 1 2.2 2.204l6.635-6.635Zm-7.743 7.744a4.71 4.71 0 0 0-2.199-2.204l-.156.155a3.918 3.918 0 0 0-.937 1.505l-.53 1.55c.28.113.501.337.61.618l1.543-.525a3.922 3.922 0 0 0 1.509-.94l.16-.16Z"
                    fill="#6200b3"
                />
                <path
                    d="M3.97 8.141c.17.858.67 1.271 1.527 1.528a.187.187 0 0 1 0 .374c-.857.171-1.27.67-1.528 1.528a.187.187 0 0 1-.373 0c-.172-.858-.671-1.27-1.528-1.528a.187.187 0 1 1 0-.374c.857-.171 1.27-.67 1.527-1.528a.187.187 0 0 1 .374 0Z"
                    fill="#6200b3"
                />
            </svg>
        </span>
        <h5 class="text-dark mt-2 mb-0" translate>ia.titulo</h5>
    </div>
</div>
<div class="modal-body">
    <div class="p-4">
        <div class="d-flex justify-content-between">
            <span class="font-size-h4 align-content-center" translate>
                ia.escolha-a-acao-desejada
            </span>
            <div
                *ngIf="{ value: loading$ | async } as loading"
                class="flex gap-2"
            >
                <ng-container
                    *ngIf="isImage; else textOptionsTemplate"
                >
                    <button
                        (click)="
                            onMagicText(
                                magicTextTypeEnum.Transcript
                            )
                        "
                        [disabled]="!!loading.value"
                        class="btn btn-bg-info btm-sm px-4 font-semibold uppercase text-white mr-2"
                    >
                        <svg-icon
                            class="flex h-6 w-6 text-theme"
                            src="assets/icons/icon-text-rewrite.svg"
                        ></svg-icon>
                        <span class="whitespace-nowrap" translate>
                            ia.tipos.transcrever
                        </span>
                    </button>
                </ng-container>
                <ng-template #textOptionsTemplate>
                    <button
                        (click)="
                            onMagicText(magicTextTypeEnum.Rewrite)
                        "
                        [disabled]="!!loading.value"
                        class="btn btn-bg-info btm-sm px-4 font-semibold uppercase text-white mr-2"
                    >
                        <svg-icon
                            class="flex h-6 w-6 text-theme"
                            src="assets/icons/icon-text-rewrite.svg"
                        ></svg-icon>
                        <span class="whitespace-nowrap" translate>
                            ia.tipos.reescrever
                        </span>
                    </button>
                    <button
                        (click)="
                            onMagicText(magicTextTypeEnum.Shorten)
                        "
                        [disabled]="!!loading.value"
                        class="btn btn-bg-info btm-sm px-4 font-semibold uppercase text-white mr-2"
                    >
                        <svg-icon
                            class="flex h-6 w-6 text-theme"
                            src="assets/icons/icon-text-shorten.svg"
                        ></svg-icon>
                        <span class="whitespace-nowrap" translate>
                            ia.tipos.encurtar
                        </span>
                    </button>

                    <button
                        (click)="
                            onMagicText(magicTextTypeEnum.Revise)
                        "
                        [disabled]="!!loading.value"
                        class="btn btn-bg-info btm-sm px-4 font-semibold uppercase text-white mr-2"
                    >
                        <svg-icon
                            class="flex h-6 w-6 text-theme"
                            src="assets/icons/icon-text-abc.svg"
                        ></svg-icon>
                        <span class="whitespace-nowrap" translate>
                            ia.tipos.corrigir-ortografia
                        </span>
                    </button>
                </ng-template>
            </div>
        </div>
        <div
            class="mt-5 rounded-xl p-4 border"
            style="max-height: 180px; overflow: auto;"
        >
            <img
                *ngIf="isImage; else textTemplate"
                class="w-full"
                [src]="data.url"
            />
            <ng-template #textTemplate>
                <div
                    [innerHTML]="data.text | safe : 'html'"
                ></div>
            </ng-template>
        </div>
    </div>
    <div
        *ngIf="{
            value: activeResultData$ | async
        } as activeResultData"
        class="flex flex-col p-4"
    >
        <div class="d-flex items-center">
            <span class="text-md font-semibold mr-2" translate
                >ia.resultado</span
            >
            <ng-container *ngIf="!!activeResultData.value">
                <button
                    (click)="onPrior()"
                    type="button"
                    class="border-0 bg-transparent"
                >
                <div class="flex-shrink-0 text-center" style="width: 15px;">
                    <i class="flaticon2-back"></i>
                </div>
                </button>
                <span>
                    {{ activeResultData.value.order }}/{{ total }}
                </span>
                <button
                    (click)="onNext()"
                    type="button"
                    class="border-0 bg-transparent"
                >
                    <div class="flex-shrink-0 text-center" style="width: 15px;">
                        <i class="flaticon2-next"></i>
                    </div>
                </button>
                <span class="text-sm">{{ activeResultData.value.type_legend | translate }}</span>
            </ng-container>
        </div>
        <div class="mt-5">
            <ng-container
                *ngIf="!!activeResultData.value; else emptyTemplate"
            >
            <gpe-editor-conteudo
                [formControl]="textEditorCtrl"
                [full]="true"
                [label]="null" [urlFileSave]="resourceEditor"
                [paramsUrlFileSave]="paramsResource"
                [heightDefault]="180"
            ></gpe-editor-conteudo>
            </ng-container>
            <ng-template #emptyTemplate>
                <ng-container *ngIf="loading$ | async; else jumbotron">
                    <div class="jumbotron text-center h-180px">
                        <div class="d-flex justify-content-center align-items-center h-100">
                            <span
                                class="m-loader--success m-loader--right m-loader"
                            ></span>
                        </div>
                    </div>
                </ng-container>
                <ng-template #jumbotron>
                    <div class="jumbotron text-center align-content-center p-15 h-180px" translate>
                        ia.escolha-a-acao-desejada
                    </div>
                </ng-template>
            </ng-template>
            <div
                class="mt-5 flex flex-col rounded-lg border px-5 py-2"
            >
                <div class="flex gap-2">
                    <svg-icon
                        class="flex w-[14px] text-base-status-info-500"
                        src="assets/icons/icon-notify-fine.svg"
                        alt="icon"
                    ></svg-icon>
                    <span class="font-semibold" translate>
                        ia.observacao
                    </span>
                </div>
                <p
                    *ngIf="isImage; else textObsTemplate"
                    class="text-sm text-zinc-900"
                    translate
                >
                    ia.ia-pode-cometer-erros-imagem
                </p>
                <ng-template #textObsTemplate>
                    <p class="text-sm text-zinc-900" translate>
                        ia.ia-pode-cometer-erros-texto
                    </p>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-danger px-2 font-semibold uppercase text-white"
        (click)="onClose()"
        [disabled]="loading$ | async"
        translate
    >
        geral.cancelar
    </button>

    <button
        type="button"
        (click)="onConfirm()"
        [disabled]="loading$ | async"
        class="btn btn-success px-2 font-semibold uppercase text-white"
        translate
    >
        geral.salvar
    </button>
</div>
